import React from "react";
import { Link } from "react-router-dom";
import { Package, Tag, ShoppingCart, LayoutGrid, Home as HomeIcon, Truck, FileText } from "lucide-react";
import AdminLayout from "@/components/AdminLayout";

const TILES = [
  { to: "/admin/prodotti", label: "Prodotti", icon: Package, color: "bg-brand-blue text-white", testid: "admin-tile-products" },
  { to: "/admin/offerte", label: "Offerte", icon: Tag, color: "bg-brand-yellow text-brand-blue", testid: "admin-tile-offers" },
  { to: "/admin/ordini", label: "Ordini", icon: ShoppingCart, color: "bg-emerald-600 text-white", testid: "admin-tile-orders" },
  { to: "/admin/categorie", label: "Categorie", icon: LayoutGrid, color: "bg-blue-600 text-white", testid: "admin-tile-cats" },
  { to: "/admin/spedizioni", label: "Spedizioni", icon: Truck, color: "bg-orange-500 text-white", testid: "admin-tile-shipping" },
  { to: "/admin/home", label: "Aspetto sito", icon: HomeIcon, color: "bg-purple-600 text-white", testid: "admin-tile-home" },
  { to: "/admin/pdf", label: "PDF digitali", icon: FileText, color: "bg-rose-600 text-white", testid: "admin-tile-pdfs" },
];

export default function AdminDashboard() {
  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={`${t.color} rounded-2xl p-5 min-h-[140px] flex flex-col justify-between shadow-sm hover:-translate-y-0.5 transition`}
            >
              <Icon className="w-8 h-8" strokeWidth={2.5} />
              <div>
                <div className="font-heading font-black text-xl">{t.label}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </AdminLayout>
  );
}
